import React, { Component } from 'react';
import './App.css';
import $ from 'jquery';


class OFirme extends Component {
    componentDidMount(){
        function resetMenu(){
            $("#home a").removeClass("active");
            $("#sluzby-a-produkty-link a").removeClass("active");
            $("#prodej-instalace-li a").removeClass("active");
            $("#lokalni-li a").removeClass("active");
            $("#outsourcing-li a").removeClass("active");
            $("#audit-is-li a").removeClass("active");
            $("#webhosting-li a").removeClass("active");
            $("#webdesign-li a").removeClass("active");
            $("#cenik-praci-li a").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#o-firme-li a").addClass("active");
    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="o-firme">
            <h1>O firmě</h1>
            <span>
            Firma RICOM Zdeněk Richtr byla založena v 1994.<br/>
            Od svého počátku se firma zabývá prodejem a servisem výpočetní  a  kancelářské  techniky. V současné době spočívá hlavní činnost firmy v poskytování komplexních outsourcingových služeb s celorepublikovou působností.
                <br/>
                Roku 2018 byla založena společnost RICOM Tech s.r.o., která postupně převezme veškeré aktivity firmy Ricom Zdeněk Richtr.
            <br/><br/>

                <b >Mezi hlavní oblasti poskytovaných služeb patří:</b>
                <ul className="text-ul ">
                 <li>Komplexní outsourcing malých a středních firem</li>
                 <li>Lokální a vzdálená správa sítí LAN a jednotlivých PC stanic</li>
                 <li>Poradenství, dodávky a instalace  HW/SW</li>
                 <li> Servis a údržba HW/SW</li>
                 <li> Webhostingové služby  a webdesign</li>
                 <li>Audity IS – kontroly legálnosti SW</li>
                 <li>Poradenství IS/IT</li>
                 <li>Školení, kurzy, semináře IT</li>
                </ul>

                <b className="font-14">Mezi další aktivity firmy patří ve spolupráci s našimi obchodními partnery:</b>
                <ul className="text-ul font-14">

             <li>Zajištění kompletních stavebních prací, rekonstrukcí a novostaveb na území ČR</li>
             <li>Zajištění geodetických služeb</li>
             <li>Zajištění komplexních projektových činností</li>
             <li>Zajištění inženýrské činnosti při přípravě a realizaci staveb</li>
             <li>Zajištění stavebního a technického dozoru</li>
                        </ul>
            </span>


        </div>


</div>
    );
  }
}

export default OFirme;



// WEBPACK FOOTER //
// ./src/OFirme.js